<div id="image-carousel" class="carousel slide" data-bs-ride="carousel" >

    <div class="carousel-inner">

        <div class="carousel-item" *ngFor="let item of items; let isFirst = first" [ngClass]="item.customClass" [class.active]="isFirst">
            <img [src]="item.image.path" [ngClass]="item.image.customClass" class="d-block w-100">
            <div class="custom-landing-page-carousel-item-text carousel-caption d-none d-md-block">
                <span class="fs-2 fw-bolder" [innerHTML]="item.title"></span><br/>
                <span class="fs-4" [innerHTML]="item.text"></span>
                <p *ngIf="item.button" class="card-text m-4">
                    <a mat-raised-button class="custom-carousel-item-button d-none d-sm-none d-md-inline-block" 
                       [innerHTML]="item.button.text" [href]="item.button.link"></a>
                </p>
            </div>
        </div>

    </div>

    <button class="carousel-control-prev" type="button" data-bs-target="#image-carousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>

    <button class="carousel-control-next" type="button" data-bs-target="#image-carousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>

</div>
